import { Component, Input, OnInit } from '@angular/core';
import { TemplateModel } from 'src/app/models/template-model.model';

@Component({
  selector: 'gabarito-panel-info',
  templateUrl: './panel-info.component.html',
  styleUrls: ['./panel-info.component.scss']
})
export class PanelInfoComponent implements OnInit {

  @Input() correctedAmount;
  @Input() questionAmount;
  @Input() appealAmount;
  @Input() correctAmount;
  @Input() isEmployee;
  @Input() isOfficial;
  @Input() correctingModel;
  @Input() hasAnswerKey;
  @Input() cancelAmount;

  @Input() panelclass;

  constructor() { }

  ngOnInit() {
  }

}
